module.exports = __webpack_public_path__ + "img/oralTest_sub29.efb6156a.png";